module.exports = __webpack_public_path__ + "img/180h100_s_fortochkoy_50h50_v_nizhney_chasti_v_centre_nizhney_chasti_.67679776.svg";